import { useQConfig } from '@exam-management/feature-qconfig-provider';
import { Table, TableContainer, type TableContainerProps } from '@shared/components';
import { randomUUID } from '@shared/utils';

import { QConfigStructureTableBody, QConfigStructureTableHeader } from '../../components';
import { type QConfigStructureData } from '../../types';

import { formatQConfigStructureToTableData } from './utils';

interface QConfigStructureTableProps extends TableContainerProps {
  data: QConfigStructureData[];
}

export default function QConfigStructureTable(props: Readonly<QConfigStructureTableProps>) {
  const { data, ...restProps } = props;

  const tableData = formatQConfigStructureToTableData(data);
  const { qConfigData } = useQConfig();
  const uuid = randomUUID();

  if (tableData.length === 0) {
    //TODO: Add empty state of subject here
    return null;
  }

  return (
    <TableContainer
      {...restProps}
      sx={{
        borderRadius: (theme) => theme.shape.rounded(2),
        overflow: 'hidden',
        border: '1px solid',
        borderColor: (theme) => theme.palette.grey[300],
        ...restProps.sx,
      }}
    >
      <Table
        stickyHeader
        size='small'
        sx={{
          border: 'none',
          borderCollapse: 'initial',
          mb: '-1px',
        }}
      >
        <QConfigStructureTableHeader status={qConfigData.status} />
        <QConfigStructureTableBody
          key={`${qConfigData.id}-${uuid}`}
          rows={tableData}
          status={qConfigData.status}
        />
      </Table>
    </TableContainer>
  );
}
